import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import useSWR, { type SWRConfiguration } from "swr";
import { config } from "@/config";
import type { GetQueries } from "@typings/api";
import { isEmpty } from "@utils/formatters";
import type { GetLocationsResponse } from "./type";

async function getLocations(query: GetQueries): Promise<GetLocationsResponse> {
  const params = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (isEmpty(value)) return;

    let paramKey = key;
    if (key === "search") {
      paramKey = "code";
    }

    params.append(paramKey, String(value));
  });

  let url = apiPaths.locations.list;
  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  const response = await apiClient.get<GetLocationsResponse>(url);

  return response.data;
}

export function useGetLocations(
  query: GetQueries | null,
  options?: SWRConfiguration,
) {
  const mergedOptions: SWRConfiguration = {
    ...config.swr,
    ...options,
  };

  return useSWR(
    [`fetch-get-locations`, JSON.stringify(query ?? {})],
    () => getLocations(query ?? {}),
    mergedOptions,
  );
}
